module.exports = __webpack_public_path__ + "img/buddy_eyebrow.13ad94a6.svg";